import React from 'react';

import { usePageTitle } from '../hooks/usePageTitle';
import { PageWithTitleProps } from '../model';

const PageWithTitle: React.FC<PageWithTitleProps> = ({
  title,
  component: Component,
}) => {
  usePageTitle(title);
  return <Component />;
};

export default PageWithTitle;
